/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

/** 
 * We are disabling these rules, 
 * because we DO want to add a click event on the main div of the Card
 **/

import React, { Component } from 'react';
import Calendar from 'react-calendar';
import { IconButton } from './iconbutton';
import moment from 'moment';
import { debounce, size } from 'lodash';

const DATE_FORMAT = "YYYY-MM-DD";

export type DatePickerProps = {
    placeholder: string,
    selectedDates: string[] | Date[],
    onDatesChange: (_dates: string[]) => void,
    locale: string
};

export type DatePickerState = {
    showPicker: boolean,
};

export class DatePicker extends Component<DatePickerProps, DatePickerState> {
    node: HTMLDivElement;

    constructor(props: DatePickerProps) {
        super(props);

        this.node = null;
        this.state = {
            showPicker: false
        };
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleOutsideClick.bind(this), false);
    }
    
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideClick.bind(this), false);
    }

    createDayPickerRangeController() {
        const datesStrOrDate = size(this.props.selectedDates) > 0 ? this.props.selectedDates : null;
        let dates: Date[] = null;

        if(datesStrOrDate != null)
            dates = datesStrOrDate.map((dateStrOrDate: Date | string) => new Date(dateStrOrDate));

        return (
            <Calendar
                onChange={this.onDatesSelected.bind(this)}
                selectRange={true}
                prevLabel={<CalendarArrow previous={true}></CalendarArrow>}
                nextLabel={<CalendarArrow previous={false}></CalendarArrow>}
                prev2Label={null}
                next2Label={null}
                minDate={new Date()}
                value={dates}
                locale={this.props.locale}
            />
        );
    }

    onDatesSelected(dates: string[]) {
        dates[0] = moment(dates[0]).format(DATE_FORMAT);
        dates[1] = moment(dates[1]).format(DATE_FORMAT);
        
        this.props.onDatesChange(dates);

        const debouncedToggle = debounce(this.togglePicker.bind(this), 100);
        debouncedToggle(this.state.showPicker);
    }

    togglePicker(showPicker) {
        this.setState({ showPicker: !showPicker });
    }

    handleOutsideClick(e) {
        if (this.node.contains(e.target))
            return;

        this.setState({showPicker: false});
    }

    render() {
        const picker = (this.state.showPicker) ? this.createDayPickerRangeController() : null;
        return (
            <div className="date-picker-container">
                <div className="date-picker-dropdown" onClick={() => this.togglePicker(this.state.showPicker)} onKeyDown={(e) => { if (e.key === 'Enter') this.togglePicker(this.state.showPicker); }} ref={node => this.node = node}>
                    <span>{this.props.placeholder}</span>
                    <i className="material-icons date-picker-input-arrow">arrow_drop_down</i>
                </div>
                <div className="date-picker-calendar" ref={node => this.node = node}>
                    {picker}
                </div>
            </div>
        );
    }
}


export type CalendarArrowProps = {
    previous?: boolean,
    onClick?: () => any
};

export function CalendarArrow({previous, onClick}: CalendarArrowProps) {
    const classNames = ["calendar-arrow"];
    if (previous)
        classNames.push("previous");
    else
        classNames.push("next");

    const icon = (previous ? "fas fa-arrow-left" : "fas fa-arrow-right");

    return <IconButton classNames={classNames} icon={{className: icon}} onClick={onClick} />;
}

